'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContentLayout = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _card = require('antd/lib/card');

var _card2 = _interopRequireDefault(_card);

var _reactRouter = require('react-router');

var _globalFooter = require('../../components/globalFooter');

var _breadCrumb = require('../../components/breadCrumb');

var _basicLayout = require('../basicLayout');

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentLayout = exports.ContentLayout = (_temp = _class = function (_BasicLayout) {
  _inherits(ContentLayout, _BasicLayout);

  function ContentLayout() {
    _classCallCheck(this, ContentLayout);

    return _possibleConstructorReturn(this, (ContentLayout.__proto__ || Object.getPrototypeOf(ContentLayout)).apply(this, arguments));
  }

  _createClass(ContentLayout, [{
    key: 'render',
    value: function render() {
      var Footer = this.getComponent('Footer');
      var BLink = this.getComponent('Link');
      var BreadCrumb = this.getComponent('BreadCrumb');
      return _react2.default.createElement(
        'div',
        { className: 'j-layout-content ' + this.props.className, style: this.props.style },
        _react2.default.createElement(BreadCrumb, { Link: BLink }),
        _react2.default.createElement(
          'div',
          { className: 'j-content' },
          _react2.default.createElement(
            _card2.default,
            { bordered: false },
            this.props.viewContent || this.props.children
          )
        ),
        _react2.default.createElement(Footer, { className: 'j-footer' })
      );
    }
  }]);

  return ContentLayout;
}(_basicLayout.BasicLayout), _class.displayName = 'ContentLayout', _class.layoutBlocks = {
  Footer: _globalFooter.GlobalFooter,
  Link: _reactRouter.Link,
  BreadCrumb: _breadCrumb.BreadCrumb
}, _temp);


//////////////////
// WEBPACK FOOTER
// ./src/layouts/contentLayout/index.jsx
// module id = 52
// module chunks = 0